import React from 'react';
import ReactDOM from 'react-dom/client';
import { reactErrorHandler } from '@sentry/react';
import { startObservability } from './lib/observability';
import './lib/medianGeolocation';
// Must stay ABOVE the React mount below. A notification tap cold-starts the app
// directly into the push listener, before any component exists to register one.
import './lib/driverPushBootstrap';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Error reports (ADR 0026), inert without REACT_APP_SENTRY_DSN. Started before
// the first render, so a failure while mounting is reported too; React's error
// hooks send what React catches, with its component stack, only when it is on.
const reporting = startObservability();
const root = ReactDOM.createRoot(
  document.getElementById('root'),
  reporting ? { onUncaughtError: reactErrorHandler(), onCaughtError: reactErrorHandler(), onRecoverableError: reactErrorHandler() } : {},
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
